const size = {
  mobile: "920px",
};

export const device = {
  mobile: `(max-width: ${size.mobile})`,
};
